import {resendConfirmationEmail} from 'actions/userActions';
import Button from 'components/common/Button';
import {CONFIRM_EMAIL_MESSAGE, PAID_PLAN_REQUIRED_MESSAGE, RESEND_CONFIRMATION_EMAIL_SUCCESS} from 'constants/messages';
import uiHelper from 'helpers/uiHelper';
import {upperFirst} from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import {useDispatch} from 'react-redux';
import {useHistory} from 'react-router-dom';
import styled from 'styled-components';
import {colors} from 'styles/shared';

const BORDER_RADIUS = '3rem';

const SectionContainer = styled.div`
  position: relative;
  width: 54.4rem;
  height: 56.4rem;
  margin-bottom: 5rem;
  padding: 3.8rem 0 0 3.8rem;
  border-radius: ${BORDER_RADIUS};
  background: url(/images/illustration-bg.svg) no-repeat;
  background-size: cover;
  background-position: top;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const Header = styled.div`
  font-weight: bold;
  font-size: 1.6rem;
  line-height: 1.9rem;
  color: ${colors.purple_dark};
  margin-bottom: 1.5rem;
`;

const Title = styled.div`
  width: 21rem;
  font-size: 3.2rem;
  line-height: 3.8rem;
  color: ${colors.darkBlue_dark};
`;

const Footer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
`;

const CustomButton = styled(Button)`
  border: 0.2rem solid white;
  margin-bottom: 3.4rem;
`;

const ImageContainer = styled.div`
  width: 28.5rem;
  height: 40.4rem;
  background: url(/images/illustration-people-small.svg) no-repeat;
  position: absolute;
  right: 0;
  border-bottom-right-radius: ${BORDER_RADIUS};
`;

PlanSection.propTypes = {
  subscribed: PropTypes.bool.isRequired,
  pending: PropTypes.bool.isRequired,
  planName: PropTypes.string
};

function PlanSection({subscribed, pending, planName}) {
  let history = useHistory();
  let dispatch = useDispatch();

  const planNameDisplay = upperFirst(planName);

  function redirectToBilling() {
    history.push('/billing');
  }

  function redirectToSubscribe() {
    history.push('/subscribe');
  }

  function sendConfirmationEmail() {
    uiHelper.showMessage(RESEND_CONFIRMATION_EMAIL_SUCCESS);
    dispatch(resendConfirmationEmail());
  }

  function render() {
    return (
      <SectionContainer>
        {subscribed ? (
          <div>
            <Header>You're on the {planNameDisplay} Plan</Header>
            <Title>Manage and view all of your Plan details</Title>
          </div>
        ) : (
          <div>
            {pending ? (
              <div>
                <Header>Email not confirmed</Header>
                <Title>{CONFIRM_EMAIL_MESSAGE}</Title>
              </div>
            ) : (
              <div>
                <Header>{PAID_PLAN_REQUIRED_MESSAGE}</Header>
                <Title>Get a free month by choosing a plan now</Title>
              </div>
            )}
          </div>
        )}

        <Footer>
          {subscribed ? (
            <CustomButton width={14.6} isActive={true} onClick={redirectToBilling}>
              Go to Billing
            </CustomButton>
          ) : (
            <div>
              {pending ? (
                <CustomButton width={14.6} isActive={true} onClick={sendConfirmationEmail}>
                  Resend email
                </CustomButton>
              ) : (
                <CustomButton width={14.6} isActive={true} onClick={redirectToSubscribe}>
                  Choose a Plan
                </CustomButton>
              )}
            </div>
          )}

          <ImageContainer />
        </Footer>
      </SectionContainer>
    );
  }

  return render();
}

export default PlanSection;
